import { HYDRATE } from "next-redux-wrapper";
import { ActionsDeletePromotion } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storeDeletePromotions(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeDeletePromotions };

	}
	case ActionsDeletePromotion.LOAD_GET_DELETE_PROMOTION:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsDeletePromotion.RES_GET_DELETE_PROMOTION:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsDeletePromotion.ERR_GET_DELETE_PROMOTION:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeDeletePromotions;
